export type TeamName = 'A' | 'B' | 'C' | 'D';

export type Player = {
  name: string;
  position?: Position;
};

export enum Formation {
  // x7x
  TwoThreeOne = '2-3-1',
  TwoTwoTwo = '2-2-2',
  ThreeTwoOne = '3-2-1',
  // 8x8
  ThreeThreeOne = '3-3-1',
  ThreeTwoTwo = '3-2-2',
  TwoThreeTwo = '2-3-2',
  TwoFourOne = '2-4-1',
  // 9x9
  ThreeThreeTwo = '3-3-2',
  ThreeTwoThree = '3-2-3',
  ThreeFourOne = '3-4-1',
}

export enum Position {
  GK = 'GK',
  CB = 'CB',
  LB = 'LB',
  RB = 'RB',
  CM = 'CM',
  DM = 'DM',
  AM = 'AM',
  LW = 'LW',
  RW = 'RW',
  ST = 'ST',
  CF = 'CF',
  LF = 'LF',
  RF = 'RF',
}

export type PitchPosition = {
  x: number | string;
  y: number | string;
  position: Position;
};

export type Team = {
  name: TeamName;
  formation?: Formation;
  players: Player[];
  theme?: FormationTheme;
  customName?: string;
};

export enum ViewMode {
  List = 'list',
  Formation = 'formation',
}

export enum FormationTheme {
  ShirtOrange = 'shirt-orange',
  ShirtRed = 'shirt-red',
  ShirtBlue = 'shirt-blue',
  ShirtBarca = 'shirt-barca',
  ShirtArgentina = 'shirt-argentina',
  ShirtPsg = 'shirt-psg',
  ShirtDarkBlue = 'shirt-darkblue',
  ShirtInter = 'shirt-inter',
  ShirtReal = 'shirt-real',
  ShirtYellow = 'shirt-yellow',
  ShirtArsenal = 'shirt-arsenal',
  ShirtBlue2 = 'shirt-blue2',
  ShirtSunderland = 'shirt-sunderland',
}

export type TeamResult = {
  teams: Team[];
  date: string;
  viewMode?: ViewMode;
};

export type Shirt = {
  img: string;
  theme: FormationTheme;
  textColor: string;
  textColorDragOver: string;
};

export type PickTeamPlayer = {
  name: string;
  appearances: number;
  points?: number;
  goals?: number;
  assists?: number;
};

export type PickTeamTeam = {
  captain: string;
  players: PickTeamPlayer[];
};

export type PickTeamResult = {
  groups: PickTeamGroup[];
  numberOfWeeks: number;
  teams: PickTeamTeam[];
  pickRound: number;
  pickedCaptains: string[];
  currentCaptain?: string;
  prevFirstCaptain?: string;
  prevLastCaptain?: string;
  startDate?: string;
  showStats?: boolean;
};

export type PickTeamGroup = {
  appearances: number;
  players: PickTeamPlayer[];
};

export type CadencePlayer = {
  name: string;
  cadence: number[];
  appearances: number;
};

export type PlayerCadenceResult = {
  dates: string[];
  players: CadencePlayer[];
};
